import Zergling from '../helpers/zergling';
import Config from "../config/main";
import {SWARM_CONFIG_DATA} from './actionTypes/';
import { SetTax } from "../actions/terminal";
import Helpers from "../helpers/helperFunctions";
import { setOddConverterPartnerConfig } from '@common/helpers/oddConverter';

/**
 * @description Set partner initial configs
 * @param {Object} message
 * @param {String} key
 * @returns {Object} new State
 */
export const SwarmConfigData = (message, key) => {
    return {
        type: SWARM_CONFIG_DATA,
        payload: message,
        key
    };
};

/**
 * @description Load additional partner configs
 * @returns {Function} async action dispatcher
 */
export function LoadPartnerConfig () {
    return function (dispatch) {
        let updatePartnerConfig = (data) => {
            console.log("partner config:", data);
            const authData = sessionStorage.getItem('authData') && JSON.parse(sessionStorage.getItem('authData'));
            const partnerConfig = data.partner[authData.pid || Config.main.site_id];
            
            setOddConverterPartnerConfig(partnerConfig);

            dispatch(SwarmConfigData(partnerConfig, "partner"));
            dispatch(SetTax({taxType: Helpers.firstElement(data.partner).tax_type, taxPercent: Helpers.firstElement(data.partner).tax_percent}));
        };
        return Zergling
            .subscribe({"source": "partner.config", 'what': {'partner': []}}, updatePartnerConfig)
            .then(response => updatePartnerConfig(response.data))
            .catch((ex) => {
                console.error("partner config load failed:", ex);
            });
    };
}

/*
 * @description Load Available Video Events
 * @returns {Function} async action dispatcher
 */

export function LoadVideoIds (callback) {
    return function (dispatch) {
        let getAvailableVideoEvents = (data) => {
            (data && data.videos) && dispatch(SwarmConfigData(data.videos, "availableVideoEvents"));
            callback && callback();
        };
        return Zergling
            .get({
                provider: Config.main.video.getProviderAvailableEventsAndEnableFiltering
            }, 'get_video_ids')
            .then(response => getAvailableVideoEvents(response))
            .catch((ex) => {
                console.error("available video events", ex);
            });
    };
}
/**
 * @description Load partner currency configs
 * @returns {Function} async action dispatcher
 */
export function LoadCurrencyConfig (currencyName) {
    return function (dispatch) {
        let updateCurrencyConfig = (data) => {
            console.log("currency config:", data);
            let currencies = {};
            Object.keys(data.currency).map(id => { currencies[data.currency[id].name] = data.currency[id]; });
            dispatch(SwarmConfigData(currencies, "currency"));
        };
        return Zergling
            .subscribe({
                'source': 'config.currency',
                'what': {'currency': []},
                'where': {'currency': {'name': {"@in": currencyName ? Config.main.availableCurrencies.indexOf(currencyName) !== -1 ? Config.main.availableCurrencies.concat([currencyName]) : Config.main.availableCurrencies : Config.main.availableCurrencies}}
                }
            }, updateCurrencyConfig)
            .then(response => updateCurrencyConfig(response.data))
            .catch((ex) => {
                console.error("CurrencyConfig load failed:", ex);
            });
    };
}